import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MUIDivider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import { Row } from '../Row';
import { units } from '../theme/units';
const useStyles = makeStyles()(() => ({
    textSeparator: {
        width: 'auto',
        flexGrow: 1,
    },
    text: {
        padding: units.yx(0, 0.3),
    },
    'kind-spaced-m': {
        margin: units.yx(1, 0),
    },
    'kind-spaced-l': {
        margin: units.yx(1.5, 0),
    },
}));
const Divider = ({ text, kind, className, dividerProps = {}, ...rest }) => {
    const { classes, cx } = useStyles();
    const divider = (_jsx(MUIDivider, { ...rest, ...dividerProps, className: cx(className, {
            [classes[`kind-${kind}`]]: Boolean(kind),
            [classes.textSeparator]: Boolean(text),
        }) }));
    // If there is no provided text, fall back to MUI divider
    if (!text) {
        return divider;
    }
    return (_jsxs(Row, { justifyContent: "space-between", alignItems: "center", children: [divider, _jsx(Typography, { className: classes.text, children: text }), divider] }));
};
export { Divider };
